<template>
  <ul>
    <li>
      {{ $t(`message.slideTenCriteriaBulletOne`) }}
    </li>
    <br />
    <li>
      {{ $t(`message.slideTenCriteriaBulletTwo`) }}
    </li>
    <br />
    <li>
      {{ $t(`message.slideTenCriteriaBulletThree`) }}
    </li>
    <br />
    <li>
      {{ $t(`message.slideTenCriteriaBulletFour`) }}
    </li>
    <br />
    <li>
      {{ $t(`message.slideTenCriteriaBulletFive`) }}
    </li>
    <br />
    <li>
      {{ $t(`message.slideTenCriteriaBulletSix`) }}
    </li>
    <br />
    <li>
      {{ $t(`message.slideTenCriteriaBulletSeven`) }}
    </li>
    <br />
    <li>
      {{ $t(`message.slideTenCriteriaBulletEight`) }}
    </li>
    <br />
    <li>
      {{ $t(`message.slideTenCriteriaBulletNine`) }}
    </li>
    <br />
    <li>
      {{ $t(`message.slideTenCriteriaBulletTen`) }}
    </li>
    <br />
    <li>
      {{ $t(`message.slideTenCriteriaBulletEleven`) }}
    </li>
    <br />
    <li>
      {{ $t(`message.slideTenCriteriaBulletTwelve`) }}
    </li>
    <br />
    <li>
      {{ $t(`message.slideTenCriteriaBulletThirteen`) }}
    </li>
    <br />
    <li>
      {{ $t(`message.slideTenCriteriaBulletFourteen`) }}
    </li>
  </ul>
</template>

<script>
export default {
  name: "FourteenCriteria"
};
</script>
